import { render, staticRenderFns } from "./staff-card.vue?vue&type=template&id=394cb716"
import script from "./staff-card.vue?vue&type=script&lang=ts"
export * from "./staff-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports